import { t } from 'i18next'
import moment from 'moment'
import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  ROUTES,
  pendingStatusDocument,
  processStatusSalesOrder,
  closeStatusDocument,
  expiredStatusDocument,
  colorsStatus,
} from 'Utils/constants'
import { generateColorStatus } from 'Utils/functions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquarePen } from '@fortawesome/free-solid-svg-icons'

export function useColumnSearchSalesOrder() {
  const [dispatchPopover, setDispatchPopover] = useState({
    openPopover: false,
    anchorEl: null,
    value: [],
  })

  const columns = useMemo(
    () => [
      {
        accessor: 'CustomerNameDocument',
        Header: t('SEARCH_QUOTATION_T.CLIENT_NAME'),
        width: '220px',
        Cell: ({ row }) => row.original.CustomerNameDocument || t('UNKNOWN'),
      },
      {
        accessor: 'DocumentNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_SALE_ORDER_LABEL'),
        width: '200px',
      },
      {
        accessor: 'OrderNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_ORDER_LABEL'),
        width: '160px',
        Cell: ({ row }) => row.original.OrderNumber || t('UNKNOWN'),
      },
      {
        accessor: 'DispatchNumbers',
        Header: t('SEARCH_QUOTATION_T.NUMBER_DESPACHO_LABEL'),
        width: '160px',
        Cell: ({ row }) => {
          const dispatches = row.original.DispatchNumbers
            ? row.original.DispatchNumbers.split(',')
            : []

          if (!dispatches.length) return t('UNKNOWN')

          return (
            <div className="sd-number-container">
              <p className="action-table-cell">{dispatches[0]}</p>
              {dispatches.length > 1 && (
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    setDispatchPopover({
                      value: dispatches,
                      anchorEl: e.currentTarget,
                      openPopover: true,
                    })
                  }}>{`+${dispatches.length - 1}`}</a>
              )}
            </div>
          )
        },
      },
      {
        accessor: 'QuoteNumber',
        Header: t('SEARCH_QUOTATION_T.NUMBER_QUOTATION_LABEL'),
        width: '185px',
        Cell: ({ row }) => row.original.QuoteNumber || t('UNKNOWN'),
      },
      {
        accessor: 'Origin',
        Header: t('SEARCH_QUOTATION_T.ORIGIN_QUOTATION_LABEL'),
        width: '80px',
        Cell: ({ row }) => (row.original.Origin === 'VA' ? 'VA' : 'Web'),
      },
      {
        accessor: 'CreatedDate',
        Header: t('SEARCH_QUOTATION_T.DATE_QUOTATION_LABEL'),
        width: '110px',
        Cell: ({ row }) =>
          moment(row.original.CreatedDate).format('DD/MM/YYYY'),
      },
      {
        accessor: 'DocHeaderStatusDescription',
        Header: t('SEARCH_QUOTATION_T.STATUS_LABEL'),
        width: '150px',
        Cell: ({ row }) => {
          const status = row.original.DocHeaderStatusDescription
          return (
            <span
              style={{
                backgroundColor: generateColorStatus(
                  status,
                  pendingStatusDocument,
                  processStatusSalesOrder,
                  closeStatusDocument,
                  expiredStatusDocument,
                  colorsStatus
                ),
                borderRadius: '5px',
                padding: '2px 8px',
                display: 'inline-block',
              }}>
              {status}
            </span>
          )
        },
      },
      {
        accessor: 'actions',
        Header: t('ACTION_TABLE_T.ACTIONS_LABEL'),
        width: '80px',
        Cell: ({ row }) => {
          const salesOrderUrl = `${ROUTES.salesOrder}${row.original.DocHeaderId}`
          return (
            <Link
              to={salesOrderUrl}
              style={{ display: 'inline-flex', alignItems: 'center' }}
              aria-label="Ver orden de venta"
              title="Ver orden de venta"
              data-testid="view-sales-order-link">
              <FontAwesomeIcon
                icon={faSquarePen}
                style={{
                  color: '#3FC5DF',
                  fontSize: '2rem',
                  cursor: 'pointer',
                }}
              />
            </Link>
          )
        },
      },
    ],
    []
  )

  return { columns, dispatchPopover, setDispatchPopover }
}
